import { Controller } from "@hotwired/stimulus"
import { setProgress } from "../progress"

export default class extends Controller {
  static targets = ["file", "progress", "processing", "uploadButton"]
  static values = { errorText: { type: String, default: "Error" } }

  connect() {
    setProgress(this.progressTarget, 0)
  }

  showUploadError() {
    // The progress element is hidden once the upload reached 100 %; show it again so the message is seen.
    this.progressTarget.textContent = this.errorTextValue
    this.progressTarget.classList.remove("hidden")
    this.processingTarget.classList.add("hidden")
    this.uploadButtonTarget.classList.remove("hidden")
  }

  submitForm(event) {
    event.preventDefault()
    const fileInput = this.fileTarget
    const form = this.element
    const progress = this.progressTarget

    if (!fileInput.files.length) return

    const formData = new FormData(form)
    progress.classList.remove("hidden")
    this.uploadButtonTarget.classList.add("hidden")

    const xhr = new XMLHttpRequest()
    xhr.open(form.method || "POST", form.action)
    // Change from JSON to Turbo Stream format
    xhr.setRequestHeader("Accept", "text/vnd.turbo-stream.html")

    xhr.upload.addEventListener("progress", (e) => {
      if (e.lengthComputable) {
        const percent = Math.round((e.loaded / e.total) * 100)
        setProgress(this.progressTarget, percent)
        if (percent === 100) {
          progress.classList.add("hidden")
          this.processingTarget.classList.remove("hidden")
        }
      }
    })

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        // Handle Turbo Stream response
        const turboStreamResponse = xhr.responseText
        if (turboStreamResponse) {
          // Let Turbo handle the stream response
          Turbo.renderStreamMessage(turboStreamResponse)
          // Hide processing indicator
          this.processingTarget.classList.add("hidden")
          this.uploadButtonTarget.classList.remove("hidden")
          // Reset the form
          this.element.reset()
        } else {
          this.processingTarget.classList.add("hidden")
          this.uploadButtonTarget.classList.remove("hidden")
        }
      } else {
        this.showUploadError()
      }
    }

    xhr.onerror = () => this.showUploadError()

    xhr.send(formData)
  }
}
